import { ModalType, useModal } from 'src/providers/ModalProvider'
import { useUser } from 'src/providers/UserProvider'

import { ActionsDropdown } from 'src/components/molecules/ActionsDropdown'

import { MembershipRoleType } from 'src/types/account'

type AccountUsersActionsProps = {
  userId?: string
  invitationId?: string
  membershipId?: string
  role?: MembershipRoleType
  accountId: string
  membershipOwnersCount?: number
}

const AccountUsersActions = ({
  userId,
  invitationId,
  membershipId,
  role,
  accountId,
  membershipOwnersCount = 0
}: AccountUsersActionsProps) => {
  const { isAccountOwner, user } = useUser()
  const { openModal } = useModal()

  const actions = []
  if (membershipId && userId !== user?.Id)
    actions.push({
      text: 'Remove user',
      onClick: () => {
        openModal(ModalType.RemoveMembership, {
          membershipId,
          accountId
        })
      }
    })
  if (membershipId && !(membershipOwnersCount === 1 && userId === user?.Id)) {
    actions.unshift({
      text: 'Change user role',
      onClick: () => {
        openModal(ModalType.UpdateMembershipRole, {
          membershipId,
          currentRole: role
        })
      }
    })
  }
  if (invitationId) {
    actions.unshift(
      {
        text: 'Resend invite',
        onClick: () => {
          openModal(ModalType.ResendInvite, {
            existingInviteId: invitationId
          })
        }
      },
      {
        text: 'Delete invite',
        onClick: () => {
          openModal(ModalType.DeleteInvite, {
            invitationId
          })
        }
      }
    )
  }

  if (!isAccountOwner) return null

  if (!actions.length) return null

  return (
    <ActionsDropdown
      actions={actions}
      buttonComponentProps={{ variant: 'outlined' }}
    >
      Actions
    </ActionsDropdown>
  )
}

export default AccountUsersActions
